module.exports = __webpack_public_path__ + "static/media/2.20.accad56a.png";